import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';

import { useRoute } from 'vue-router';
import { ref, watch, onMounted } from 'vue';

import AuthService from '@/classes/AuthService';
import locationService from '@/classes/LocationService';
import Company from '@/classes/Company';

// const router = useRouter();

export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const route = useRoute();
const branchId = ref(route.params.id);

const loader = ref(false)
const errors = ref([]);
const show = ref(false);
const showSuccess = ref(false);
const showError = ref(false);
const errorMsg = ref(false);

const form = ref({
    name: null,
    address_line: null,
    region: null,
    region_code: null,
    province: null,
    province_code: null,
    city: null,
    city_code: null,
    barangay: null,
    barangay_code: null,
    zip_code: null,
    mobile_number: null,
    branch_id: branchId.value
})


const submit = () => {
    loader.value = true;

    Company.storeCompany(form.value)
        .then(() => {
            loader.value      = false;
            show.value        = false;
            showSuccess.value = true
            
            setTimeout(() => {
                window.location.replace(`branches/${branchId.value}/companies/`)
            }, 2000);
        })
        .catch((err) => {
            loader.value    = false;
            show.value      = false;
            showError.value = true;
            errorMsg.value  = err.response.data.message;

            if(err.response.status == 422) {
                errors.value = err.response.data.errors;
            }
            errorResponse(err)
        })
}

const errorResponse = (err: object) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}

/**
 * 
 * Local Address Functions
 * 
 */
const provinces = ref([]);
const regions = ref([]);
const cities = ref([]);
const barangays = ref([]);


const fetchData = () => {
        loader.value = true

        locationService.fetchRegions()
        .then((result: any) => {
            loader.value = false
            regions.value = result.data
        })
        .catch((err: any) => errorResponse(err) )
}

 const fetchProvince = () => {
    loader.value = true
    locationService.fetchProvinces(`code=${form.value.region_code}&level=Prov`)
    .then((result: any) => {
        loader.value = false
        provinces.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

 const fetchCity = () => {
    loader.value = true
    locationService.fetchCities(`code=${form.value.province_code}&level=Mun`)
    .then((result: any) => {
        loader.value = false
        cities.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const fetchBrgy = () => {
    loader.value = true
    locationService.fetchBarangays(`code=${form.value.city_code}&level=Bgy`)
    .then((result: any) => {
        loader.value = false
        barangays.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const clearProvince = () => {
    form.value.province_code = null
    form.value.city_code = null
    form.value.barangay_code = null
}

const clearCity = () => {
    form.value.city_code = null
    form.value.barangay_code = null
}

const clearBgy = () => {
    form.value.barangay_code = null
}
 
watch(
      () => form.value.barangay_code,
      (val) => {
        if(val) {
            form.value.barangay = barangays.value.find((e) => e.code == val)?.label
        }
      },
      { immediate: true }
    );

watch(
      () => form.value.city_code,
      (val) => {
        barangays.value = [];
        if(val) {
            form.value.city = cities.value.find((e) => e.code == val)?.label
            fetchBrgy()
        }
      },
      { immediate: true }
    );

watch(
      () => form.value.province_code,
      (val) => {
        cities.value = [];
        barangays.value = [];
        if(val) {
            form.value.province = provinces.value.find((e) => e.code == val)?.label
            fetchCity()
        }
      },
      { immediate: true }
    );

watch(
      () => form.value.region_code,
      (val) => {
        cities.value = [];
        barangays.value = [];
        provinces.value = [];
        if(val) {
            form.value.region = regions.value.find((e) => e.code == val)?.label
            fetchProvince()
        }
      },
      { immediate: true }
    );

onMounted(() => fetchData())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Create Company",
    "show-back": "",
    backUrl: `/branches/${branchId.value}/companies`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          errors: errors.value,
          regions: regions.value,
          provinces: provinces.value,
          cities: cities.value,
          barangays: barangays.value,
          onClearProvince: clearProvince,
          onClearCity: clearCity,
          onClearBgy: clearBgy
        }, {
          default: _withCtx(() => [
            _createVNode(ButtonComponent, { onClick: submit }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Submit ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form", "errors", "regions", "provinces", "cities", "barangays"])
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Company",
        content: "Company Created Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"])
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})